<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="o-form__modal__bg"></div>
        <div class="o-form__modal">
            
            <div class="o-text o-form__modal__inner" v-if="!result.status">
                <h3>
                    {{ _t('Attention, vous demandez la reprise d\'un formulaire sauvegardé.') }}
                </h3>
                <p>
                    {{ _t('Êtes-vous certain de vouloir continuer avec la reprise?') }}
                </p>
                <div class="o-button-group">
                    <button
                        class="o-button -button-stroke"
                        @click="closeModal"
                        :disabled="(result.loading) ? 'disabled': false"
                    >
                        {{ _t('Nouveau formulaire') }}
                    </button> 
                    <button
                        class="o-button"
                        @click="recoverForm"
                        :disabled="(result.loading) ? 'disabled': false"
                        ref="recoverButton"
                    >
                        {{ _t('Reprendre le formulaire') }}
                    </button>
                </div>
            </div>
            <div class="o-text o-form__modal__inner" v-else>
                <h3 class="recover-success" v-html="result.message" v-if="result.status=='success'">
                </h3>
                <h3 class="recover-error" v-html="result.message" v-else>
                </h3>
                <p v-html="result.messageAlt" v-if="result.messageAlt">
                </p>
                <div class="o-button-group">
                    <button
                        class="o-button"
                        @click="closeModal"
                        :disabled="(result.loading) ? 'disabled': false"
                        ref="recoverCompleteButton"
                    >
                        {{ _t('Continuer') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'FormRecoverModal',
        props: {
            entryID: {
                type: Number,
                value: null
            },
            siteID: {
                type: Number,
                value: null
            },
            form: {
                type: Object,
                value: null
            }
        },
        data(){
        	return {
                recoverHash: null,
                result: {
                    status: null,
                    message: null,
                    messageAlt: null,
                    hashedURL: null,
                    loading: false,
                },
        	}
        },
        mounted(){
            let url = new URL(window.location)
            this.recoverHash = url.searchParams.get('recover');
            url.searchParams.delete('recover');
            history.replaceState(null, '', url);

            this.$refs.recoverButton.focus()
        },
        methods: {
        
            closeModal: function(){
                this.$emit('close-modal')            
            },

            findField: function(fieldID) {
                let found = false
                this.form.sections.forEach(section => {
                    if(found) return
                    section.fields.forEach(fields => {
                        if(found) return
                        if (!fields.fieldsList) return
                        fields.fieldsList.forEach(field => {
                            if(found) return
                            if(field.id == fieldID) found = field
                        })
                    })
                })


                return found
            },

            findFieldsList: function (fieldsID) {
                let found = false
                this.form.sections.forEach(section => {
                    section.fields.forEach(fields => {
                        if(fields.id == fieldsID) found = fields
                    })
                })
                return found

            },

            recoverForm: function(){

                this.result = {
                    status: null,
                    message: null,
                    messageAlt: null,
                    hashedURL: null,
                    loading: true,
                }


                if (!this.$root.session) {
                    this.$root.getSessionInfo().then((session) => {
                        this.recoverForm();
                    });
                    return
                }


                let headers = {
                    'Accept': 'application/json',
                    'X-CSRF-Token': this.$root.session.csrfTokenValue,
                    'X-Requested-With': 'XMLHttpRequest',
                };

                fetch('/flexibleform/recover/' + this.siteID + '/' + this.entryID + '/' + this.recoverHash, {
                    method: 'POST',
                    headers: headers,
                })
                .then(response => response.json())
                .then(data => {

                    if(data.form) {
                        data.form.sections.forEach(section => {
                            section.fields.forEach(fields => {
                                if (!fields.fieldsList) return
                                if (fields.groupIsRepeater && fields.groupIsRepeater === true) {
                                    let found = this.findFieldsList(fields.id)
                                    if (found) {
                                        found.fieldsList = fields.fieldsList
                                    }
                                }
                                fields.fieldsList.forEach(field => {
                                    let found = this.findField(field.id)
                                    if(found) {
                                        found.value = field.value
                                    }
                                })
                            })
                        })

                        this.form.id = data.form.id
                        this.form.currentStep = data.form.currentStep
                    }

                    this.result = {
                        loading: false,
                        status: data.status,
                        message: data.message,
                        messageAlt: data.messageAlt,
                    }
                    this.$nextTick(() => {
                        this.$refs.recoverCompleteButton.focus()
                    })
                })
                .catch((error) => {
                    this.result = {
                        loading: false,
                        status: 'error',
                        message: error,
                    }

                    console.error('Error:', error)
                })
                .finally(() => {
                    // this.result.loading = false
                })

            
            }

        },
    }
</script>